import { createFileRoute } from "@tanstack/react-router";

// Cửa "Điều hành khung" (CEO chốt 01/09/2026) — bảng đội, chốt kỳ, mốc, giám
// sát, cấu hình. Việc của người quản khung, mở vài lần một tháng; để chung với
// màn nhân viên xem hằng ngày là chôn cả hai.
type PerformanceSearch = { tab?: string | undefined };

export const Route = createFileRoute("/_app/performance/admin")({
  validateSearch: (search: Record<string, unknown>): PerformanceSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
});
